"use client"

import { useState, useEffect } from "react"
import backquien from "../img/backquien.png"
import backquien2 from "../img/backquien2.png"
import "./css/quienes-somos.css"

// Hook personalizado para detectar si estamos en móvil
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkIsMobile()
    window.addEventListener("resize", checkIsMobile)
    return () => window.removeEventListener("resize", checkIsMobile)
  }, [])

  return isMobile
}

const QuienesSomos = () => {
  const isMobile = useIsMobile()

  return (
    <section className="quienes-somos-section" id="Somos">
      <div className="quienes-somos-container">
        <div className="background-image">
          <img
            src={isMobile ? backquien2 : backquien || "/placeholder.svg"}
            alt="Equipo de trabajo en almacén"
            className="background-img"
          />
        </div>
        <div className="content-overlay">
          <div className="text-content">
            <h2 className="section-title">QUIENES SOMOS:</h2>
            <p className="section-description">
              Servicio aduanero y logística integral con experiencia en comercio aduanero. Enfocados en soluciones
              específicas para importaciones y exportaciones, basados en principios de honradez, honestidad y
              responsabilidad. Infraestructura logística y recursos tecnológicos, cada uno de ellos orientados a brindar
              el servicio aduanero que nuestros clientes requieren y necesitan, apegándonos a tiempos de entrega y
              maximizando recursos.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default QuienesSomos
